import api from '../../utils/apiFetch';

const path = 'organizations';
export default {
  getOrgs: () => api.get(`${path}`),
};
